import * as React from 'react';

import * as TimeUtils from '@acceligentllc/shared/utils/time';

import type TimeZoneSourceType from 'ab-enums/timezoneSourceType.enum';
import { TimeZoneSourceTypeLabel } from 'ab-enums/timezoneSourceType.enum';

import { Button } from '@acceligentllc/storybook';

import Tooltip from 'af-components/Tooltip';

import styles from './styles.module.scss';

interface OwnProps {
	timezoneInUse: Nullable<string>;
	timezoneSourceType: Nullable<TimeZoneSourceType>;
	showLocalTimeZone?: boolean;
	changeTimeZone?: () => void;
}

type Props = OwnProps;

const INFO_TOOLTIP_TEXT = 'This location determines the Time zone for Time Sheets.';
const TIME_ZONE_TEXT_PREFIX = 'Timezone determined by';
const NO_TIME_ZONE_TEXT = 'Timezone could not be determined';
const LOCAL_TIME_ZONE_TEXT = 'All times are shown in your local time zone';

const TimeZoneSourceBanner: React.FC<Props> = (props: Props) => {
	const { timezoneInUse, timezoneSourceType, showLocalTimeZone = false, changeTimeZone } = props;

	const renderText = React.useCallback(() => {
		if (timezoneInUse && timezoneSourceType) {
			const timezoneText = `${TIME_ZONE_TEXT_PREFIX} ${TimeZoneSourceTypeLabel[timezoneSourceType]}`;
			const timezoneAbbreviation = TimeUtils.abbreviateTimeZone(timezoneInUse, 'z (Z)');

			return (
				<>
					{timezoneText}: <b>{timezoneAbbreviation}</b>
				</>
			);
		}

		const timezoneAbbreviation = TimeUtils.abbreviateTimeZone(timezoneInUse, 'z (Z)');
		return showLocalTimeZone
			? (
				<>
					{LOCAL_TIME_ZONE_TEXT}: <b>{timezoneAbbreviation}</b>
				</>
			)
			: NO_TIME_ZONE_TEXT;
	}, [timezoneInUse, timezoneSourceType, showLocalTimeZone]);

	return (
		<div className={styles['time-zone']}>
			<div className={styles['time-zone__banner']}>
				<span className="icon-clock" />
				{renderText()}
				<Tooltip
					message={INFO_TOOLTIP_TEXT}
				>
					<span className="icon-info"></span>
				</Tooltip>
			</div>
			{
				changeTimeZone && <div className="time-sheet-list__time-zone__swithc">
					<Button
						label="Change"
						onClick={changeTimeZone}
						size="small"
						style="link"
					/>
				</div>
			}
		</div >
	);
};

export default React.memo(TimeZoneSourceBanner);
